import {motion} from 'framer-motion';
import { useSelector } from 'react-redux';

const fadeIn = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.3 } },
};

const statusColor = (status: string) => {
  switch (status) {
    case "active": case "confirmed": case "completed":
      return "bg-emerald-50 text-emerald-700 border-emerald-200";
    case "pending":
      return "bg-amber-50 text-amber-700 border-amber-200";
    case "suspended": case "inactive":
      return "bg-red-50 text-red-700 border-red-200";
    default:
      return "bg-muted text-muted-foreground";
  }
};

const recentBookings = [
  { id: "B-001", customer: "Emily Watson", provider: "Amara Beauty Studio", service: "Hair Coloring", date: "Mar 30, 2026", amount: "$85", status: "confirmed" },
  { id: "B-002", customer: "James Miller", provider: "Urban Barber Co.", service: "Haircut & Beard", date: "Mar 30, 2026", amount: "$45", status: "completed" },
  { id: "B-003", customer: "Lisa Chang", provider: "Zen Wellness Spa", service: "Deep Tissue Massage", date: "Mar 31, 2026", amount: "$120", status: "pending" },
  { id: "B-004", customer: "Sarah Kim", provider: "Glow Nails Lounge", service: "Gel Manicure", date: "Apr 1, 2026", amount: "$55", status: "confirmed" },
];

export default function Bookings()  {
    // const {bookings} = useSelector(state => state.bookings)
    return(
        <motion.div key="bookings" {...fadeIn}>
              <h3 className="text-lg font-semibold text-foreground mb-4">All Bookings</h3>
              <div className="rounded-xl border border-border bg-background overflow-hidden">
                <div className="overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="border-b border-border bg-muted/30">
                        <th className="text-left px-4 py-3 font-medium text-muted-foreground">ID</th>
                        <th className="text-left px-4 py-3 font-medium text-muted-foreground">Service</th>
                        <th className="text-left px-4 py-3 font-medium text-muted-foreground hidden sm:table-cell">Customer</th>
                        <th className="text-left px-4 py-3 font-medium text-muted-foreground hidden md:table-cell">Provider</th>
                        <th className="text-left px-4 py-3 font-medium text-muted-foreground">Amount</th>
                        <th className="text-left px-4 py-3 font-medium text-muted-foreground">Status</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-border">
                      {recentBookings.map((b) => (
                        <tr key={b.id} className="hover:bg-muted/20 transition-colors">
                          <td className="px-4 py-3 text-muted-foreground">{b.id}</td>
                          <td className="px-4 py-3 font-medium text-foreground">{b.service}</td>
                          <td className="px-4 py-3 text-muted-foreground hidden sm:table-cell">{b.customer}</td>
                          <td className="px-4 py-3 text-muted-foreground hidden md:table-cell">{b.provider}</td>
                          <td className="px-4 py-3 font-medium text-foreground">{b.amount}</td>
                          <td className="px-4 py-3">
                            <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-medium ${statusColor(b.status)}`}>{b.status}</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </motion.div>
    )
}